import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/terminals/')({
  beforeLoad: () => {
    throw redirect({ to: '/terminals/locations', replace: true });
  },
});
